import { useContext } from 'react'
import { Typography, Button } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next'
import { GlobalContext } from '../../context/GlobalContext'
import SessionExpiredIcon from '../../assets/Clock.svg'
import './SessionExpired.scss'

const SessionExpired = () => {
  const { t } = useTranslation()
  const [state, dispatch]: any = useContext(GlobalContext)
  const { rtl } = state
  const dir = rtl ? 'right' : 'left'
  

  function ClickTrackAginBtn() {
    dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'TrackMyOrder' } })
  }

  return (
    <>
      <Typography rtl={rtl} className="listOfOrdersScreen_title1">{t('your_orders')}</Typography>
      <div className="center">
        <img className="clockIcon" src={SessionExpiredIcon} alt="mobilyIcon" />
        <Typography rtl={rtl} className="SessionExpired_title">{t('session_expired')}</Typography>

        <Typography rtl={rtl} className="SessionExpired_subtitle">{t('session_expired_subtitle')}</Typography>

        <Button
          className="TrackAgain__modalBtn"
          primary={true}
          rtl={rtl}
          onClick={ClickTrackAginBtn}
        >
          {t('track_again')}
        </Button>
      </div>
    </>
  )
}
export default SessionExpired
